import React, { createContext, useContext } from 'react';

const SocketContext = createContext(null);

export function SocketProvider({ children, socket }) {
  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
export default SocketProvider;

// Custom hook for easy access
export const useSocket = () => useContext(SocketContext);